import React from "react";
import ContractForm from "pages/ContractForm";
import IndexRegistration from "pages/IndexRegistration";
import "assets/css/main.scss";
import packageJson from "../package.json";
// exclude boostrap from being loaded in the production build
// if (process.env.REACT_APP_ENV === "production") {
//    require("assets/css/main-production.scss");
// } else {
//    require("assets/css/main.scss");
// }

// Log environment and package version
console.info("env", process.env.REACT_APP_ENV);
console.info("version", packageJson.version);

const App = () => {
  const isIndexRegistrationPage = window.location.pathname.includes("/trimite-index");

  return isIndexRegistrationPage ? <IndexRegistration /> : <ContractForm />;
};

export default App;

// trigger build
